import React, {useEffect, useState} from 'react';
import {Button} from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import Timer from "react-compound-timer";
import {makeStyles} from "@material-ui/core/styles";
import "./styles/StyleCoutndownClock.css";
import {useRecoilValue, useSetRecoilState} from "recoil";
import {
    durationState, timeOutState, requiredTimeState, requiredTimeSubmitState, testStatusState
} from "../../states/states";
import withUrlParams from "../HOC/withUrlParams";
import {currentTestState} from "../../states/test_progress_states";
import SweetAlert from 'react-bootstrap-sweetalert';
import i18n from 'i18next';

const useStyles = makeStyles(() => ({
    iconClock: {
        marginRight: 6
    },
}));

function CountdownClock(props) {
    const {isShowClock} = props;
    const classes = useStyles();
    const [showSweetAlert, setShowSweetAlert] = useState(false);
    const duration = useRecoilValue(durationState);
    const currentTest = useRecoilValue(currentTestState);
    const setTimeOut = useSetRecoilState(timeOutState);
    const requiredTime = useRecoilValue(requiredTimeState); //Thời gian làm bài tối thiểu
    const setRequiredTimeSubmit = useSetRecoilState(requiredTimeSubmitState);
    const testStatus = useRecoilValue(testStatusState);
    let now = new Date();
    // let studentStartTime = Date.parse(currentTest.studentStartTime);
    // let initialTime = duration * 60 * 1000 - (now.getTime() - studentStartTime);
    // if (initialTime < 0)
    //     initialTime = 0;
    let initialTime = currentTest.remainingTime ? (1000 * currentTest.remainingTime) : 0;
    let endTime = now.getTime() + initialTime;
    let isTimeUp = false;

    const checkTime = () => {
        if (currentTest && currentTest.duration && currentTest && !isTimeUp) {
            let remainingTime = getRemainingTime();
            if (remainingTime < (currentTest.duration * 60 * 1000 - requiredTime * 1000)) {
                setRequiredTimeSubmit(true);
            }
            if (isTimeUp !== (remainingTime === 0))
                isTimeUp = (remainingTime === 0);
            if (showSweetAlert !== (remainingTime === 0))
                setShowSweetAlert(remainingTime === 0);
        }
    };


    useEffect(() => {
        if (currentTest && currentTest.studentStartTime)
        {
            // setInterval(checkTime, 1000);
            checkTime();
        }

    }, [currentTest]);

    const getRemainingTime = () => {

        let now = new Date();
        let remainingTime = endTime - now.getTime();
        if (remainingTime < 0)
            remainingTime = 0;
        return remainingTime;
    };

    let elmButtonClock = "";
    if (isShowClock && duration && currentTest) {
        elmButtonClock = (
            <div>
                <Button color="inherit">
                <span className="box-timer"><AccessTimeIcon className={classes.iconClock}/>
                    <Timer initialTime={initialTime} direction="backward"
                           checkpoints={[
                               {
                                   time: 0,
                                   callback: () => {
                                       if (!isTimeUp) {
                                           isTimeUp = true;
                                           setShowSweetAlert(true);
                                       }

                                   },
                               }
                           ]}
                    >
                            {({getTime, setTime}) => (
                                <React.Fragment>
                                    <Timer.Hours formatValue={(text) => (text.toString().length > 1 ? text : "0" + text)}/>
                                    :<Timer.Minutes formatValue={(text) => (text.toString().length > 1 ? text : "0" + text)}/>
                                    :<Timer.Seconds formatValue={(text) => (text.toString().length > 1 ? text : "0" + text)}/>
                                    {getTime() - getRemainingTime() > 500 && setTime(getRemainingTime())}
                                </React.Fragment>
                            )}
                    </Timer>
                </span>
                </Button>
                <div className={"timeOutSweetAlert"}>
                    <SweetAlert
                        show={showSweetAlert}
                        title={i18n.t('alert_time_out')}
                        confirmBtnText={i18n.t('alert_submit')}
                        confirmBtnBsStyle="primary"
                        openAnim={{name: 'showSweetAlert', duration: 500}}
                        btnSize="sm"
                        onConfirm={() => {
                            setShowSweetAlert(false);
                            setTimeOut(true);
                        }}
                    >
                    </SweetAlert>
                </div>
                {requiredTime && testStatus.current_status === "inProgressStatus" ?
                    <Timer initialTime={requiredTime * 1000} direction="backward"
                           checkpoints={[
                               {
                                   time: 0,
                                   callback: () => {
                                       setRequiredTimeSubmit(true);
                                   },
                               }
                           ]}
                    /> : ""}
            </div>

        );
    }else if(requiredTime && testStatus.current_status === "inProgressStatus"){
        elmButtonClock = (
            <Timer initialTime={requiredTime * 1000} direction="backward"
                   checkpoints={[
                       {
                           time: 0,
                           callback: () => {
                               setRequiredTimeSubmit(true);
                           },
                       }
                   ]}
            />
        )
    }

    return (
        <React.Fragment>
            {elmButtonClock}
        </React.Fragment>
    );
}

export default withUrlParams(CountdownClock);
